import api from "../config/api";
import {
  CreateCheckoutLinkRequest,
  CreateCheckoutLinkResponse,
} from "@/queries/checkout/types";

export interface CreateCheckoutLinkParams {
  userId: string;
  payload: CreateCheckoutLinkRequest;
}

export interface DeleteCheckoutLinkParams {
  userId: string;
}

export interface GetCheckoutLinkParams {
  userId: string;
}

export const getCheckoutLink = async ({
  userId,
}: GetCheckoutLinkParams): Promise<string> => {
  const url = `/quickpay/checkout/${userId}/link`;
  const { data } = await api.get(url);
  return data.data;
};

export const createCheckoutLink = async ({
  userId,
  payload,
}: CreateCheckoutLinkParams): Promise<CreateCheckoutLinkResponse> => {
  const url = `/quickpay/checkout/${userId}/link`;
  const response = await api.post(url, payload);
  const link = response.headers.location || "";
  return {
    checkout: response.data?.checkout || {},
    link,
  };
};

export const deleteCheckoutLink = async ({
  userId,
}: DeleteCheckoutLinkParams): Promise<void> => {
  const url = `/quickpay/checkout/${userId}/link`;
  await api.delete(url);
};
